import { cn, MarkdownText, Text } from '@viapeople/components'
import type { ComponentProps, ParagraphCustomProps } from './types'
import { getLabelVariant } from './utils'

export const FormsParagraph = ({ component }: ComponentProps) => {
	const {
		label,
		labelColor,
		labelSize,
		labelWeight,
		backgroundColor,
		text,
		textColor: _textColor,
	} = component.custom as ParagraphCustomProps

	return (
		<div
			className={cn('w-full flex flex-col text-left', backgroundColor && 'p-4 rounded-md')}
			style={{ backgroundColor: backgroundColor || undefined }}>
			{label && (
				<Text
					variant={getLabelVariant(labelSize, 'h6')}
					weight={(labelWeight !== 'hidden' && labelWeight) || 'semibold'}
					className={cn('mb-1', labelWeight === 'hidden' && 'hidden')}
					style={{ color: labelColor }}>
					{label}
				</Text>
			)}
			{text && <MarkdownText markdown={text} variant='small' />}
		</div>
	)
}
